import iconPath from '@/assets/device-icons/iphone-13.svg';

interface Iphone13IconProps {
  className?: string;
}

export const Iphone13Icon = ({ className = "h-5 w-5" }: Iphone13IconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iPhone 13" 
      className={className}
    />
  );
};
